// extracted by mini-css-extract-plugin
export default {"table":"Table_table__gAa6K","note":"Table_note__aRIkw","orders":"Table_orders__2MGTi"};